import { WEB } from '../../common-message-format/constants/clientTypes';
import { CHANNEL_SPECIFIC_OPAQUE_ID } from '../../common-message-format/constants/deliveryIdentifierTypes';
import { LIVE_CHAT_GENERIC_CHANNEL_ID } from '../../common-message-format/constants/genericChannelIds';
import { INCOMING } from '../../common-message-format/constants/messageDirections';
import { SENT } from '../../common-message-format/constants/statusTypes';
import { VISITOR_SENDER } from '../../common-message-format/constants/cmfSenderTypes';
import { buildCMFSender } from '../../common-message-format/operators/buildCMFSender';
import { generateUuid } from '../../util/generateUuid';
import { CUSTOMER_AGENT_FEEDBACK_MESSAGE } from '../constants/messageTypes';
import CustomerAgentFeedbackMessage from '../records/CustomerAgentFeedbackMessage';
export const buildCustomerAgentFeedbackMessage = ({
  channelInstanceId,
  senderId,
  messageId,
  feedbackType,
  redactingFeedbackMessageId
}) => {
  const visitorSender = buildCMFSender({
    deliveryIdentifier: {
      type: CHANNEL_SPECIFIC_OPAQUE_ID,
      value: senderId
    }
  });
  return new CustomerAgentFeedbackMessage({
    '@type': CUSTOMER_AGENT_FEEDBACK_MESSAGE,
    channelInstanceId,
    clientType: WEB,
    direction: INCOMING,
    genericChannelId: LIVE_CHAT_GENERIC_CHANNEL_ID,
    id: generateUuid(),
    inResponseToMessageId: messageId,
    redactingFeedbackMessageId: redactingFeedbackMessageId !== null && redactingFeedbackMessageId !== void 0 ? redactingFeedbackMessageId : null,
    sender: {
      '@type': VISITOR_SENDER,
      utk: senderId
    },
    senders: [visitorSender],
    status: {
      messageStatus: SENT
    },
    text: '',
    timestamp: Date.now(),
    type: feedbackType
  });
};